import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map, shareReplay } from "rxjs/operators";
import { CrudService } from "./crud.service";
import { HorasEsperaConfig } from "src/models/horas-espera-config.model";

const DISABLED_CONFIG: HorasEsperaConfig = { valorHora: 0, limiteHoras: 0 };

@Injectable({ providedIn: "root" })
export class HorasEsperaConfigService {
  private config$: Observable<HorasEsperaConfig> | null = null;

  constructor(private crud: CrudService) {}

  getConfig(): Observable<HorasEsperaConfig> {
    if (!this.config$) {
      this.config$ = this.crud.getData("Configuration/horas-espera").pipe(
        map((res: any) => ({
          valorHora: Number(res?.valorHora ?? 0),
          limiteHoras: Number(res?.limiteHoras ?? 0),
        })),
        catchError(() => of(DISABLED_CONFIG)),
        shareReplay(1)
      );
    }
    return this.config$;
  }
}
